// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FilterBar_FilterBar__DMA-w{display:flex;flex-wrap:wrap;gap:.3rem;justify-content:flex-start}`, "",{"version":3,"sources":["webpack://./src/features/common/components/SpotonDataTable/FilterBar.module.scss"],"names":[],"mappings":"AAAA,4BACE,YAAA,CACA,cAAA,CACA,SAAA,CACA,0BAAA","sourcesContent":[".FilterBar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n  justify-content: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"FilterBar": `FilterBar_FilterBar__DMA-w`
};
export default ___CSS_LOADER_EXPORT___;
